import { Award, MapPin, UtensilsCrossed } from "lucide-react";
import { Reveal } from "./Reveal";

const BADGES = [
  { icon: Award, name: "First Save", detail: "Your first Saved place" },
  { icon: MapPin, name: "Neighborhood Explorer", detail: "Dine in 5 new areas" },
  { icon: UtensilsCrossed, name: "Cuisine Trailblazer", detail: "Try 10 cuisines" },
];

export const Achievements = () => (
  <section
    id="achievements"
    data-testid="achievements-section"
    className="scroll-mt-24 border-y border-crave-border bg-[#181514] py-24 md:py-32"
  >
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 md:px-12 lg:grid-cols-2">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-crave-border">
          <img
            src="https://images.unsplash.com/photo-1663530761401-15eefb544889?q=80&w=1000&auto=format&fit=crop"
            alt="A chef's signature dish, beautifully plated"
            loading="lazy"
            className="h-80 w-full object-cover md:h-[28rem]"
          />
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-gradient-to-t from-crave-bg/70 via-transparent to-transparent"
          />
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">
          Personal Achievements
        </p>
        <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-crave-cream sm:text-5xl">
          Milestones worth savoring
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-crave-muted">
          Track your own exploration — new neighborhoods, new cuisines, places crossed off your
          list. Badges mark your personal journey, and they're private by default: display them
          only if you choose to.
        </p>

        <ul className="mt-10 space-y-4">
          {BADGES.map((badge, i) => (
            <li
              key={badge.name}
              data-testid={`achievement-badge-${i}`}
              className="flex items-center gap-4 rounded-2xl border border-crave-border bg-crave-card px-5 py-4 transition-colors duration-300 hover:border-crave-gold/40"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-crave-gold/30 bg-crave-gold/10 text-crave-gold">
                <badge.icon className="h-5 w-5" aria-hidden="true" />
              </span>
              <span>
                <span className="block text-sm font-semibold text-crave-cream">{badge.name}</span>
                <span className="block text-xs text-crave-muted">{badge.detail}</span>
              </span>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-sm leading-relaxed text-crave-muted">
          No public feed, no follower counts — just a quiet record of everywhere your taste has
          taken you.
        </p>
      </Reveal>
    </div>
  </section>
);
